/**
 * Normalizes the CSL patch type to the desired format.
 * If the patch type is empty or missing, it will be normalized to 'document'.
 * @param patch - The CSL patch to normalize.
 * @returns The normalized CSL patch.
 */
export const normalizeCslPatchType = (patch: object | null | undefined): object | null => {
  if (!patch || typeof patch !== 'object') {
    return patch ?? null;
  }

  const cslPatched = { ...patch } as Record<string, unknown>;
  const cslType: string = typeof cslPatched.type === 'string' ? cslPatched.type : '';

  // document is a catch-all type - https://docs.citationstyles.org/en/stable/specification.html#document
  if (cslType === '') {
    return {
      ...cslPatched,
      type: 'document',
    };
  }

  return cslPatched;
};
